const config = {
    app: {
        env: process.env.APP_ENV ?? 'dev',
        url: process.env.APP_URL ?? "http://localhost:8002",
        customer_space_url: process.env.CUSTOMER_SPACE_URL ?? "https://dev.espace.klian.fr",
        subscription_url: process.env.SUBSCRIPTION_URL ?? 'https://dev.souscription.klian.fr'
    },
    api: {
        url: process.env.API_URL ?? "https://360.api.re7.tech/",
        url_v1: process.env.API_URL_V1 ?? "https://api.re7.tech/",
    },
    stripe: {
        public_key:
            process.env.STRIPE_PUBLIC_KEY ?? "pk_test_51JpZDxCWlPpMd2zn5uGxytrjGfQmi80np3Hg5s4gS7SDx5vYciVwedJQzzRoaCOS81bTKUN9Hcj49I3MoqZHVeXG00PCADaTS3",
    },
    iba: {
        url: process.env.IBA_URL ?? "https://test.ibapplications.com",
    },
    isicom: {
        enable: process.env.ISICOM_ENABLE ?? true,
        ws_url: process.env.ISICOM_WS_URL ?? "https://app-kli.isi-com.cloud/ctiws/"
    },
    check_iban: process.env.CHECK_IBAN === 'true' ? true : false
};

export default config;
